export const getTokens = (theme) => /* scss */ `
    --header-bar-height: ${theme.tokens.FuelSpacing12};
    --header-append-height: ${theme.tokens.FuelSpacing8};

    --header-height-desktop: var(--header-bar-height);
    --header-height-mobile: calc(var(--header-bar-height) + var(--header-append-height));

    // box-shadow: inset 0 0 0px 2px ${theme.tokens.FuelColorFocused};
    --menu-item-outline-type-focus: inset;
    --menu-item-outline-position-focus: 0 0;
    --menu-item-outline-blur-focus: 0px;
    --menu-item-outline-spread-focus: 2px;
    --menu-item-outline-color-focus: ${theme.tokens.FuelColorFocused};
    --menu-item-outline-focus: var(--menu-item-outline-type-focus) var(--menu-item-outline-position-focus) var(--menu-item-outline-blur-focus) var(--menu-item-outline-spread-focus) var(--menu-item-outline-color-focus);
`;
